import { TabInfo } from 'editor/src/store/editorModules/sidebar/types';
import { RootState } from 'editor/src/store/index';

const getSidebarActiveTab = (state: RootState): TabInfo | undefined => {
  const { activeTabIndex, tabs } = state.editorModules.sidebar;
  return tabs[activeTabIndex];
};

export default getSidebarActiveTab;
